import React from "react";
import { Link } from "react-router-dom";
import { KeyRound, CheckCircle2, Clock, Ban } from "lucide-react";
import { useLabText, safeStore } from "../../lib/labText";

const ICONS = { approved: CheckCircle2, pending: Clock, suspended: Ban, rejected: Ban };
const gold = "text-[11px] uppercase tracking-[0.25em] px-6 py-3.5 transition-colors";

export const ParticipationBox = ({ user, participant, onRequest }) => {
  const { t } = useLabText();
  const st = participant?.status;
  const Icon = ICONS[st] || KeyRound;
  return (
    <section data-testid="lab-participation" className="border border-[#262421] bg-[#0F0E0C] p-6 md:p-8">
      <p className="flex items-center gap-2 text-[11px] uppercase tracking-[0.3em] text-[#C49A6C]"><KeyRound size={14} />{t("private_access")}</p>
      {st ? (
        <p className="flex items-start gap-2.5 mt-4 text-[#F2EBE1] leading-relaxed" data-testid={`lab-status-${st}`}>
          <Icon size={18} className={`mt-0.5 shrink-0 ${st === "approved" ? "text-[#7FB77E]" : "text-[#C49A6C]"}`} />{t(`st_${st}`)}
        </p>
      ) : (
        <p className="text-sm text-[#B8B0A4] mt-3 max-w-xl leading-relaxed">{t("req_note")}</p>
      )}
      {user && (!st || st === "rejected") && (
        <button onClick={onRequest} data-testid="lab-request-btn" className={`${gold} mt-5 bg-[#C49A6C] text-[#0B0A08] hover:bg-[#E7CBA9]`}>{t("request")}</button>
      )}
      {!user && (
        <div className="mt-5">
          <p className="text-xs text-[#8A857D]">{t("need_login")}</p>
          <div className="flex flex-wrap gap-3 mt-4">
            <Link to="/login" onClick={() => safeStore.set("omr_next", "/experiments")} data-testid="lab-login" className={`${gold} bg-[#C49A6C] text-[#0B0A08] hover:bg-[#E7CBA9]`}>{t("login")}</Link>
            <Link to="/register" onClick={() => safeStore.set("omr_next", "/experiments")} data-testid="lab-register" className={`${gold} border border-[#C49A6C] text-[#C49A6C] hover:bg-[#C49A6C] hover:text-[#0B0A08]`}>{t("register")}</Link>
          </div>
        </div>
      )}
    </section>
  );
};
